<template>
	<div>
		<case-form :schema="identification" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			Doctor Information
		</div>
		<case-form :schema="doctorInformation" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			Specialist Information
		</div>
		<case-form :schema="specialistInformation" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	data() {
		return {}
	},

	computed: {
		identification() {
			return [
				{
					label: "Government ID Number",
					component: "entityIdentity",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].identities",
					bindTo: `case.facts.insured0governmentIdNumber`,
					props: {
						suggest: {
							typeIncludes: "governmentIdNumber"
						},
						createOptions: {
							type: "governmentIdNumber"
						}
					}
				},
				{
					label: "Country of Issue",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0governmentIdCountryOfIssue`,
					props: {
						suggest: {
							typeIncludes: `governmentIdCountryOfIssue`
						},
						createOptions: {
							type: `governmentIdCountryOfIssue`,
							dataType: "string"
						}
					}
				},
				{
					label: "Passport Number",
					component: "entityIdentity",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].identities",
					bindTo: `case.facts.insured0passportNumber`,
					props: {
						suggest: {
							typeIncludes: "passportNumber"
						},
						createOptions: {
							type: "passportNumber"
						}
					}
				},
				{
					label: "Country of Issue",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0passportCountryOfIssue`,
					props: {
						suggest: {
							typeIncludes: `passportCountryOfIssue`
						},
						createOptions: {
							type: `passportCountryOfIssue`,
							dataType: "string"
						}
					}
				},
				{
					label: "Identification Expiration Date",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0identificationDateOfExpiration`,
					props: {
						suggest: {
							typeIncludes: `identificationDateOfExpiration`
						},
						createOptions: {
							type: `identificationDateOfExpiration`,
							dataType: "date"
						}
					}
				}
			]
		},

		doctorInformation() {
			return [
				{
					label: `Given Name/First Name of personal physician or health care advisor`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorFirstName`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorFirstName`
						},
						createOptions: {
							type: `personalDoctorFirstName`,
							dataType: "string"
						}
					}
				},
				{
					label: `Family Name/Last Name of personal physician or health care advisor`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorLastName`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorLastName`
						},
						createOptions: {
							type: `personalDoctorLastName`,
							dataType: "string"
						}
					}
				},
				{
					label: `Name of medical clinic or hospital`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorHospital`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorHospital`
						},
						createOptions: {
							type: `personalDoctorHospital`,
							dataType: "string"
						}
					}
				},
				{
					label: "Address",
					component: "entityAddress",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0personalDoctorAddress",
					props: {
						suggest: {
							typeIncludes: "personalDoctorAddress"
						},
						createOptions: {
							type: "personalDoctorAddress"
						}
					}
				},
				{
					label: "Telephone No.",
					component: "entityContact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].contacts",
					bindTo: "case.facts.insured0personalDoctorPhoneNo",
					props: {
						suggest: {
							typeIncludes: `personalDoctorPhoneNo`
						},
						createOptions: {
							type: `personalDoctorPhoneNo`,
							dataType: "string"
						}
					}
				},
				{
					label: "Fax No.",
					component: "entityContact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].contacts",
					bindTo: "case.facts.insured0personalDoctorFaxNo",
					props: {
						suggest: {
							typeIncludes: `personalDoctorFaxNo`
						},
						createOptions: {
							type: `personalDoctorFaxNo`,
							dataType: "string"
						}
					}
				},
				{
					label: `Name on file (if different than legal name)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorNameOnFile`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorNameOnFile`
						},
						createOptions: {
							type: `personalDoctorNameOnFile`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date last visited`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorDateLastVisited`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorDateLastVisited`
						},
						createOptions: {
							type: `personalDoctorDateLastVisited`,
							dataType: "date"
						}
					}
				},
				{
					label: `Reason for last medical consultation`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorReasonForLastConsultation`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorReasonForLastConsultation`
						},
						createOptions: {
							type: `personalDoctorReasonForLastConsultation`,
							dataType: "string"
						}
					}
				},
				{
					label: `Treatment or medication prescribed and results of any tests completed`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorPrescription`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorPrescription`
						},
						createOptions: {
							type: `personalDoctorPrescription`,
							dataType: "string"
						}
					}
				}
			]
		},

		specialistInformation() {
			return [
				{
					label: `Given Name/First Name of personal physician or health care advisor`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorFirstName`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorFirstName`
						},
						createOptions: {
							type: `otherDoctorFirstName`,
							dataType: "string"
						}
					}
				},
				{
					label: `Family Name/Last Name of personal physician or health care advisor`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorLastName`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorLastName`
						},
						createOptions: {
							type: `otherDoctorLastName`,
							dataType: "string"
						}
					}
				},
				{
					label: `Specialty`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorSpeciality`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorSpeciality`
						},
						createOptions: {
							type: `otherDoctorSpeciality`,
							dataType: "string"
						}
					}
				},
				{
					label: `Name of medical clinic or hospital`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorHospital`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorHospital`
						},
						createOptions: {
							type: `otherDoctorHospital`,
							dataType: "string"
						}
					}
				},
				{
					label: "Address",
					component: "entityAddress",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0specialistDoctorAddress",
					props: {
						suggest: {
							typeIncludes: "specialistDoctorAddress"
						},
						createOptions: {
							type: "specialistDoctorAddress"
						}
					}
				},
				{
					label: "Telephone No.",
					component: "entityContact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].contacts",
					bindTo: "case.facts.insured0specialistDoctorTel",
					props: {
						suggest: {
							typeIncludes: `specialistDoctorTel`
						},
						createOptions: {
							type: `specialistDoctorTel`,
							dataType: "string"
						}
					}
				},
				{
					label: "Fax No.",
					component: "entityContact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].contacts",
					bindTo: "case.facts.insured0specialistDoctorFax",
					props: {
						suggest: {
							typeIncludes: `specialistDoctorFax`
						},
						createOptions: {
							type: `specialistDoctorFax`,
							dataType: "string"
						}
					}
				},
				{
					label: `Name on file (if different than legal name)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorNameOnFile`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorNameOnFile`
						},
						createOptions: {
							type: `otherDoctorNameOnFile`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date last visited`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorDateLastVisited`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorDateLastVisited`
						},
						createOptions: {
							type: `otherDoctorDateLastVisited`,
							dataType: "date"
						}
					}
				},
				{
					label: `Reason for last medical consultation`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorReasonForLastConsultation`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorReasonForLastConsultation`
						},
						createOptions: {
							type: `otherDoctorReasonForLastConsultation`,
							dataType: "string"
						}
					}
				},
				{
					label: `Treatment or medication prescribed and results of any tests completed`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorPrescription`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorPrescription`
						},
						createOptions: {
							type: `otherDoctorPrescription`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
